/**
 * Syncs the custom scrollbar thumb with horizontal scroll for customer reviews carousel.
 */
(function () {
  function updateThumb(scrollEl, thumbEl) {
    if (!scrollEl || !thumbEl) return;
    var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
    var visibleRatio = scrollEl.clientWidth / scrollEl.scrollWidth;
    var thumbWidthPct = Math.min(100, Math.max(visibleRatio * 100, 9));
    var leftPct = 0;
    if (maxScroll > 0) {
      leftPct = (scrollEl.scrollLeft / maxScroll) * (100 - thumbWidthPct);
    }
    thumbEl.style.width = thumbWidthPct + '%';
    thumbEl.style.left = leftPct + '%';
  }

  function bind(root) {
    var track = root.querySelector('[data-crc-track]');
    var thumb = root.querySelector('[data-crc-thumb]');
    if (!track || !thumb) return;

    var onScroll = function () {
      updateThumb(track, thumb);
    };

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(onScroll);
      ro.observe(track);
    }

    onScroll();
  }

  function initAll() {
    document.querySelectorAll('[data-crc-section]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-crc-section]');
    if (root) bind(root);
  });
})();
